import { createAction } from "@reduxjs/toolkit";

/* Analytics actions */
export const viewThankYou = createAction("thankYou/viewThankYou");
